import {Component, Input, OnInit} from '@angular/core';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';

@Component({
    selector: 'app-technical-device-preview',
    templateUrl: './technical-device-preview.component.html',
})
export class TechnicalDevicePreviewComponent implements OnInit {

    @Input() technicalDevice: TechnicalDeviceNamespace.ApiDataInterface;

    constructor() {
    }

    ngOnInit() {

    }
}
